import { FormErrors } from 'redux-form';
import { ModelRuleView } from '@Selectors/searchModelRule/make/view/ModelRuleView';
import { UnitView } from '@Selectors/searchModelRule/make/view/UnitView';

const validate = (
  values: SearchModelRuleParams,
): FormErrors<SearchModelRuleParams> => {
  const errors: FormErrors<SearchModelRuleParams> = {};

  if (!values.versionId) {
    errors.versionId = 'You must select a version.';
  }

  if (!values.armyIds || values.armyIds.length === 0) {
    errors.armyIds = 'You mus select an army.';
  }

  if (!values.modelRuleId) {
    errors.modelRuleId = 'You must select a special rule.';
  }

  return errors;
};
export default validate;

export type SearchModelRuleParams = {
  versionId: number;
  armyIds: Array<number>;
  rules: Array<ModelRuleView>;
  modelRuleId: string;
  units: Array<UnitView>;
};
